export default __webpack_public_path__ + "30b4be9899e0355e1e87f5a227b7c2b3.svg";